type Props = { value: number; size?: 'sm' | 'lg'; className?: string };

export function Stars({ value, size = 'sm', className }: Props) {
  const filled = Math.max(0, Math.min(5, Math.round(value)));
  return (
    <span className={`row-stars${size === 'lg' ? ' d-rating' : ''}${className ? ' ' + className : ''}`} aria-label={`${value} von 5 Sternen`}>
      {[1, 2, 3, 4, 5].map((n) =>
        n <= filled ? <span key={n}>★</span> : <span key={n} className="empty">★</span>,
      )}
    </span>
  );
}
